import axios from 'axios'

const state = {
    viewComponent : 'UnlimitedGolfSearchView',
    golfItems: [],
    isInstant: true,
    showModal: false,
}

const mutations = { 
    INIT_MODAL(state) {
        state.showModal = true;
    },
    CLOSE_MODAL(state) {
        state.showModal = false;
    },
    CLEAR_ALL(state) {
            state.isInstant = true,
            state.showModal = false,
            state.golfItems = []
    },
    INSERT_GOLF_ITEMS(state, payload) {
       state.golfItems = payload.data;
    },
}
const actions = {
    fetchGolfItems({ commit }, payload) {
        commit('CLEAR_ALL');
        commit('INIT_MODAL');

        var condoReferer = localStorage.getItem('condo-referer');
        var url = 'https://devscripts.execdigi.com/meridian/v2/index.php?action=get_unlimited_quote&StartDate=' +
            payload.data.StartDate + '&EndDate=' + payload.data.EndDate;

        if(condoReferer){
            var obj = JSON.parse(condoReferer);

            url = url + '&Initial_REQUEST_URI=' + obj.landing + '&Initial_HTTP_REFERER=' + obj.referer;
        }

        axios.post(url).then(res => {
            let items = res.data;
            console.log(items);
            commit('INSERT_GOLF_ITEMS', items);
            commit('CLOSE_MODAL');
        })        
    },

}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
